module.exports = __webpack_public_path__ + "img/Playmaker-Dual-Bundle.77f20792.png";